export default __webpack_public_path__ + "static/StM Strategic Plan 2024-2026-02b40e5a28660f27181c44890a7ef732.pdf";